import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ServicesGrid.css";
import { SERVICE_ROUTES } from "../constants/serviceRoutes";

const SINGLE_CLICK_DELAY_MS = 220;
const AUTO_RESUME_DELAY_MS = 5000;

const services = [
  {
    id: 2,
    name: "Data Visualization",
    image:
      "https://blackroth-images.s3.ap-south-1.amazonaws.com/data%2BVisualization.jpg.jpeg",
    route: SERVICE_ROUTES.dataVisualization,
  },
  {
    id: 3,
    name: "R&D",
    image: "https://blackroth-images.s3.ap-south-1.amazonaws.com/IMG_1808.jpeg",
    route: "/research-and-development",
  },
  {
    id: 4,
    name: "UI/UX Design",
    image: "https://blackroth-images.s3.ap-south-1.amazonaws.com/uiux.jpg",
    route: "/ui-ux-design-services",
  },
  {
    id: 5,
    name: "Cloud Services",
    image:
      "https://blackroth-images.s3.ap-south-1.amazonaws.com/cloud.jpg.jpeg",
    route: "/cloud-services",
  },
];

const ServicesGrid = () => {
  const navigate = useNavigate();
  const cardRefs = useRef(new Map());
  const clickTimeoutRef = useRef(null);
  const resumeTimeoutRef = useRef(null);
  const [focusedOffset, setFocusedOffset] = useState(null);

  useEffect(() => {
    return () => {
      clearTimeout(clickTimeoutRef.current);
      clearTimeout(resumeTimeoutRef.current);
    };
  }, []);

  const setCardRef = (key, node) => {
    if (node) {
      cardRefs.current.set(key, node);
      return;
    }

    cardRefs.current.delete(key);
  };

  const focusCardPair = (copyIndex, serviceIndex) => {
    const anchorCopyIndex = serviceIndex === 0
      ? Math.max(0, copyIndex - 1)
      : copyIndex;
    const anchorServiceIndex = serviceIndex === 0
      ? services.length - 1
      : serviceIndex - 1;
    const anchorCard = cardRefs.current.get(
      `${anchorCopyIndex}-${anchorServiceIndex}`,
    );

    if (!anchorCard) return;

    setFocusedOffset(anchorCard.offsetLeft);
    clearTimeout(resumeTimeoutRef.current);
    resumeTimeoutRef.current = setTimeout(() => {
      setFocusedOffset(null);
    }, AUTO_RESUME_DELAY_MS);
  };

  const handleSingleClick = (copyIndex, serviceIndex) => {
    clearTimeout(clickTimeoutRef.current);
    clickTimeoutRef.current = setTimeout(() => {
      focusCardPair(copyIndex, serviceIndex);
    }, SINGLE_CLICK_DELAY_MS);
  };

  const handleDoubleClick = (service) => {
    clearTimeout(clickTimeoutRef.current);
    clearTimeout(resumeTimeoutRef.current);
    navigate(
      service.route,
      service.route === "/research-and-development" ? { state: { fromHomeScroll: true } } : undefined,
    );
  };

  return (
    <div className="services-grid-container">
      <div className="services-escalator">
        <div
          className={`services-escalator-track${focusedOffset !== null ? " is-focused" : ""}`}
          style={
            focusedOffset !== null
              ? { transform: `translateX(-${focusedOffset}px)` }
              : undefined
          }
        >
          {[0, 1].map((copyIndex) => (
            <div
              key={`services-copy-${copyIndex}`}
              className="services-escalator-group"
              aria-hidden={copyIndex === 1}
            >
              {services.map((service, serviceIndex) => (
                <div
                  key={`${copyIndex}-${service.id}`}
                  className="services-grid-card"
                  onClick={() => handleSingleClick(copyIndex, serviceIndex)}
                  onDoubleClick={() => handleDoubleClick(service)}
                  ref={(node) =>
                    setCardRef(`${copyIndex}-${serviceIndex}`, node)
                  }
                >
                  <img
                    src={service.image}
                    alt={service.name}
                    draggable="false"
                    loading="lazy"
                  />
                  <div className="services-grid-overlay">{service.name}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesGrid;
